import { render, staticRenderFns } from "./check-case.vue?vue&type=template&id=c816a87a&scoped=true"
import script from "./check-case.vue?vue&type=script&lang=ts"
export * from "./check-case.vue?vue&type=script&lang=ts"
import style0 from "./check-case.vue?vue&type=style&index=0&id=c816a87a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c816a87a",
  null
  
)

export default component.exports